var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeLazer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 51,
    viewBox: "0 0 114 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_687_10884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9871 31.1221H1.50006",
    stroke: "#DA3832",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9968 10.5684H84.5098",
    stroke: "#DA3832",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.785 33.8892H102.298",
    stroke: "#DA3832",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7751 38.6333H19.2881",
    stroke: "#DA3832",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7894 25.8197L96.9561 22.9863",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7227 25.8197L102.556 22.9863",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88 18.7045L106.047 15.8711",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.813 18.7045L111.647 15.8711",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7019 28.7515H6.2149",
    stroke: "#DA3832",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8811 16.7753C23.8553 16.7753 27.0771 13.5535 27.0771 9.5793C27.0771 5.60506 23.8553 2.3833 19.8811 2.3833C15.9068 2.3833 12.6851 5.60506 12.6851 9.5793C12.6851 13.5535 15.9068 16.7753 19.8811 16.7753Z",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.406 25.3766C46.7054 25.5676 47.0681 25.6327 47.4152 25.5578C47.7624 25.4829 48.066 25.274 48.26 24.9766L48.288 24.9186L48.305 24.9086C54.496 19.4086 63.139 22.3356 63.225 22.3666L63.28 22.3806C63.5607 22.5373 63.8893 22.585 64.203 22.5145C64.5167 22.444 64.7933 22.2603 64.98 21.9986C65.007 21.9606 68.034 17.9816 74.927 19.7836C75.0539 19.8164 75.1851 19.8293 75.316 19.8216C75.6018 19.9156 75.9111 19.9096 76.193 19.8046C76.5271 19.6798 76.7982 19.4276 76.9465 19.1032C77.0948 18.7789 77.1083 18.4089 76.984 18.0746C73.696 9.25959 63.457 4.28258 52.633 6.24658L52.575 6.26059H52.568L52.159 6.34259C52.0571 6.35243 51.9565 6.3732 51.859 6.40457C41.441 8.61657 33.977 16.6986 34.002 25.8816C34.0039 26.2373 34.1462 26.578 34.3982 26.8292C34.6501 27.0804 34.9912 27.2218 35.347 27.2226C35.5343 27.2221 35.7195 27.1821 35.8903 27.105C36.0611 27.028 36.2137 26.9157 36.338 26.7756C42.052 22.7526 46.21 25.2526 46.406 25.3766ZM48.16 21.6246C47.834 13.4796 51.4 10.1576 52.851 9.14658C54.571 9.58358 59.083 11.4466 61.639 19.2036C58.534 18.6326 53.038 18.3226 48.16 21.6246ZM73.343 16.7376C71.7776 16.4832 70.1771 16.5435 68.6352 16.9149C67.0933 17.2863 65.6409 17.9613 64.363 18.9006C62.657 13.3836 60.012 10.2816 57.635 8.54459C64.326 8.67859 70.362 11.7876 73.346 16.7376H73.343ZM48.053 10.4376C46.502 12.8796 45.198 16.6146 45.498 22.1486C42.6059 21.4477 39.5565 21.8488 36.944 23.2736C37.983 17.8346 42.22 12.9916 48.054 10.4366L48.053 10.4376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.771 4.47653L53.419 3.99853L53.082 2.15155C53.0182 1.8008 52.8177 1.48975 52.5246 1.28683C52.2314 1.08392 51.8698 1.00576 51.519 1.06955C51.1683 1.13333 50.8572 1.33383 50.6543 1.62695C50.4514 1.92007 50.3732 2.28179 50.437 2.63254L50.771 4.47653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.649 46.1445H57.907L58.578 49.7445C58.6348 50.0534 58.7981 50.3326 59.0394 50.5336C59.2808 50.7345 59.5849 50.8446 59.899 50.8445C59.9821 50.8444 60.065 50.8374 60.147 50.8235C60.4982 50.7578 60.8089 50.5552 61.0109 50.2605C61.2128 49.9657 61.2895 49.6028 61.224 49.2515L60.649 46.1445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.887 24.4995L56.601 39.0865H59.335L56.535 24.0115C55.6367 24.0735 54.7483 24.2372 53.887 24.4995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5181 27.0075C87.5993 26.8481 87.6479 26.6741 87.6611 26.4957C87.6743 26.3172 87.6518 26.138 87.5949 25.9683C87.538 25.7987 87.4478 25.6421 87.3297 25.5077C87.2116 25.3733 87.0679 25.2638 86.9069 25.1857C86.746 25.1075 86.5711 25.0622 86.3924 25.0524C86.2137 25.0426 86.0349 25.0686 85.8664 25.1287C85.6979 25.1888 85.543 25.282 85.4109 25.4026C85.2789 25.5233 85.1721 25.6691 85.097 25.8315L80.7391 34.8255H65.379C65.0223 34.8255 64.6802 34.9672 64.428 35.2195C64.1757 35.4717 64.0341 35.8138 64.0341 36.1705C64.0341 36.5272 64.1757 36.8694 64.428 37.1216C64.6802 37.3738 65.0223 37.5155 65.379 37.5155H68.822L66.5731 41.2745H42.025C41.6683 41.2745 41.3262 41.4163 41.074 41.6685C40.8217 41.9207 40.6801 42.2628 40.6801 42.6195C40.6801 42.9763 40.8217 43.3184 41.074 43.5706C41.3262 43.8229 41.6683 43.9645 42.025 43.9645H47.1121L44.1851 48.8485C44.094 49.0002 44.0338 49.1684 44.0079 49.3434C43.9819 49.5183 43.9908 49.6967 44.0339 49.8683C44.077 50.0399 44.1535 50.2013 44.259 50.3432C44.3646 50.4852 44.4971 50.6049 44.649 50.6956C44.8564 50.8216 45.0944 50.8884 45.337 50.8885C45.5697 50.8889 45.7986 50.829 46.0012 50.7145C46.2038 50.6001 46.3732 50.435 46.493 50.2355L50.249 43.9655H76.832L80.5881 50.2355C80.6791 50.3871 80.799 50.5192 80.9411 50.6244C81.0832 50.7296 81.2446 50.8058 81.4161 50.8486C81.5876 50.8914 81.7658 50.9 81.9407 50.8739C82.1155 50.8478 82.2835 50.7875 82.4351 50.6965C82.5866 50.6055 82.7187 50.4856 82.8239 50.3435C82.9291 50.2014 83.0053 50.04 83.0481 49.8685C83.0909 49.697 83.0995 49.5187 83.0734 49.3439C83.0473 49.1691 82.9871 49.0011 82.8961 48.8495L79.584 43.3255C79.6143 43.2885 79.6421 43.2494 79.6671 43.2086L87.5181 27.0075ZM71.9581 37.5075H79.4321L77.678 41.1325C77.6099 41.1836 77.5373 41.2285 77.4611 41.2665H69.709L71.9581 37.5075Z",
    fill: "#DA3832"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_687_10884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.769,
    height: 50,
    fill: "white",
    transform: "translate(0 0.883301)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeLazer);
export default __webpack_public_path__ + "static/media/icone-lazer.a6aa89d9bd5b3783c4ec1f014dc3ca59.svg";
export { ForwardRef as ReactComponent };